import React, { useEffect, useState } from 'react';

import Footer from '@bharatpe/bharat-ui/web/Footer';
import Typography from '@bharatpe/bharat-ui/web/Typography';
import PageLayout from '@bharatpe/bharat-ui/web/PageLayout';
import { customSubScribeBackButton, getURLParameter } from 'utils/nativeSupport';
import secureGreen from 'assets/icons/Autopay/secureGreen.svg';

import './styles.scss';
import Card from '@bharatpe/bharat-ui/web/Card';
import { JuspayPaymentModesSlice, SET_MANDATE_CREATED_DETAILS, useOnBoardingRedirection, useUpiData } from 'Slices';
import { useDispatch } from 'react-redux';
import history from 'utils/History';
import { formatDateDynamic, isEmpty } from 'utils/Utils';
import { registerSlice } from 'store';
import {
	fetchUpiProfile,
	forgetUPIPin,
	manageMandate,
	openDeepLinkWithCallback,
	TriggerNativeApiWrapper,
} from 'utils/nativeUpiHandler';
import AppHeader from 'components/atoms/AppHeader';
import { SET_MANDATE_DETAILS } from 'Slices/GetMandate';
import { API_URL } from 'Services/CONSTANT';
import Toasty from 'components/atoms/Toasty';
import { BottomSheet, Button, CheckCircle, Icon, Loader } from '@bharatpe/bharat-ui';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import WrongPinModal from 'components/organisms/Modals/WrongPinModal';
import AlertIcon from 'assets/icons/Autopay/danger.svg';
import { deviceBindingRedirectionHandle } from 'utils/deviceBindingHelper';
import { sendEvent } from 'utils/Sentry';
import { triggerSettlementAccountApi, useSettlementAccount } from 'Slices/GetSettlementAccount';
import { triggerCustomerSettlementAccountApi, useCustomerSettlementAccount } from 'Slices/GetCustomerSettlementAccount';
import { ONBOARDING_REDIRECTION_PAGE, UPI_ERROR_CODE } from 'utils/CONSTANT';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';
registerSlice(JuspayPaymentModesSlice);

const AutoPay: React.FC = () => {
	const dispatch = useDispatch();
	const upiData = useUpiData();
	const [loading, setLoading] = useState<boolean>(false);
	const [showWrongPinModal, setShowWrongPinModal] = useState<boolean>(false);
	const [showPinChangedSuccessfulModal, setPinChangedSuccessfulModal] = useState(false);
	const onBoardingRedirection = useOnBoardingRedirection();
	const settlementAccount = useSettlementAccount();
	const customerSettlementAccount = useCustomerSettlementAccount();
	const { languageData } = useLanguageConfig();

	const { account } = upiData?.upiProfileDetails?.user_banks[0] || [];

	const [mandateDetails, setMandateDetails] = useState<any>();
	const didEnterWrongPin = getURLParameter(window.location.href, 'wrong-pin');

	useEffect(() => {
		switch (onBoardingRedirection.source) {
			case ONBOARDING_REDIRECTION_PAGE.PROFILE:
				dispatch(triggerCustomerSettlementAccountApi());

				break;
			case ONBOARDING_REDIRECTION_PAGE.MANDATE:
				dispatch(triggerSettlementAccountApi());
				break;
		}
	}, [dispatch]);

	useEffect(() => {
		if (didEnterWrongPin === 'true') {
			setShowWrongPinModal(true);
		}
	}, [didEnterWrongPin]);

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Page view',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'Create',
			Module: 'Page',
			Action: 'View',
		});
		setLoading(true);
		if (!isEmpty(getURLParameter(window.location.href, 'txnId'))) {
			const txnId = getURLParameter(window.location.href, 'txnId');
			(async () => {
				try {
					const data: any = await TriggerNativeApiWrapper(`${API_URL.getMandate}/${txnId}/get-mandate`, 'POST', {}, {});
					setLoading(false);
					setMandateDetails(data?.data);
					dispatch(SET_MANDATE_DETAILS(data?.data));
				} catch (err: any) {
					sendEvent(err);

					Toasty.error(err?.error || 'something went wrong');
				}
			})();
		} else {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		customSubScribeBackButton(() => {
			onBack();
		});
	}, [history]);

	const getSelectedBank = (bankList: any) => {
		let bankData: any;

		switch (onBoardingRedirection.source) {
			case ONBOARDING_REDIRECTION_PAGE.PROFILE:
				if (customerSettlementAccount.data) bankData = customerSettlementAccount?.data?.data;
				else {
					const redirectUri = getURLParameter(window.location.href, 'redirectURIDeeplink');
					openDeepLinkWithCallback(redirectUri, () => {
						Toasty.error('Something went wrong');
					});
				}

				break;
			case ONBOARDING_REDIRECTION_PAGE.MANDATE:
				if (settlementAccount.data) bankData = settlementAccount?.data?.data;
				else {
					const redirectUri = getURLParameter(window.location.href, 'redirectURIDeeplink');
					openDeepLinkWithCallback(redirectUri, () => {
						Toasty.error('Something went wrong');
					});
				}
				break;
		}
		const selectedBank = bankList.find(
			(bank: any) => bank?.ifsc == bankData?.ifsc && bank?.account?.slice(-4) == bankData?.account?.slice(-4),
		);

		return selectedBank;
	};

	const handleContinueClick = async (source: string) => {
		if (source === 'FOOTER')
			logAnalyticsEvent({
				trigger_point: 'Clicks Continue',
				Product: 'AutoPayUPI',
				Flow: 'SetupUPI',
				Screen: 'Create',
				Module: 'Continue',
				Element: 'CTA',
				Action: 'Tapped',
				ctaType: 'retry',
			});

		if (source === 'WRONG_PIN_MODAL')
			logAnalyticsEvent({
				trigger_point: 'Clicks on Reset PIN',
				Product: 'AutoPayUPI',
				Flow: 'SetupUPI',
				Screen: 'Create',
				Module: 'Reset_Pin',
				Element: 'CTA',
				Action: 'Tapped',
				ctaType: 'resetPin',
			});
		try {
			setLoading(true);
			setShowWrongPinModal(false);
			const data = await fetchUpiProfile(upiData?.profileId || '');
			const { profileDetails } = data as any;
			console.log('profileDetails', profileDetails);
			if (profileDetails) {
				try {
					const details = await manageMandate(
						mandateDetails?.unity_mandate_details,
						getSelectedBank(profileDetails?.user_banks),
					);
					if (!isEmpty(details)) {
						dispatch(SET_MANDATE_CREATED_DETAILS(details));
						setLoading(false);
						history.push({ pathname: '/upi/auto-pay-successfull' });
					}
				} catch (error: any) {
					setLoading(false);
					if (error.errorCode == 'ZM') {
						setShowWrongPinModal(true);
						logAnalyticsEvent({
							trigger_point: 'Modal View',
							Product: 'AutoPayUPI',
							Flow: 'SetupUPI',
							Screen: 'WPin',
							Module: 'Modal',
							Action: 'Viewed',
						});
					} else if (error.errorCode == 'Z6') {
						Toasty.error('Exceeded number of pin tries');
					} else if (error.errorCode == '995') {
						//
					} else if (UPI_ERROR_CODE.includes(error?.errorCode)) {
						Toasty.error(error?.error);
					} else {
						Toasty.error('Something went wrong!!');
					}
				}
			} else {
				setLoading(false);
				Toasty.error('Something went wrong !!!');
			}
		} catch (err: any) {
			setLoading(false);
			if (UPI_ERROR_CODE.includes(err?.errorCode)) Toasty.error(err?.error);
			else Toasty.error('Something went wrong !!!');
		}
	};

	if (loading) return <Loader loading />;

	const onBack = () => {
		logAnalyticsEvent({
			trigger_point: 'Clicks on back button',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'Create',
			Element: 'back',
			Action: 'Tapped',
			source: 'appHeader',
		});
		deviceBindingRedirectionHandle(true);
	};

	const handlePinReset = async () => {
		logAnalyticsEvent({
			trigger_point: 'Clicks on Reset PIN',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'WPin',
			Module: 'Reset_Pin',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'resetPin',
		});
		setShowWrongPinModal(false);
		try {
			const isSuccess = await forgetUPIPin(upiData?.upiProfileDetails?.user_banks[0]);
			if (isSuccess) setPinChangedSuccessfulModal(true);
		} catch (error: any) {
			if (error.errorCode == 'ZM') {
				setShowWrongPinModal(true);
			} else if (error.errorCode == 'Z6') {
				Toasty.error('Exceeded number of pin tries');
			} else if (UPI_ERROR_CODE.includes(error?.errorCode)) {
				Toasty.error(error?.error);
				sendEvent(error);
			} else {
				sendEvent(error);
				Toasty.error('Something went wrong!!');
			}
		}
	};
	const handlePinChnageConfirmationClose = () => {
		setPinChangedSuccessfulModal(false);
	};

	return (
		<PageLayout
			className="pb18 white-background"
			footerContent={
				<Footer primaryActionText={languageData.CONTINUE} primaryAction={() => handleContinueClick('FOOTER')} />
			}>
			<>
				<AppHeader title={''} leftIconAction={onBack} />

				<div className="mx5 mt6 text-center">
					<Typography variant="Bold700" className="text-center mt4 width-100" component="span">
						{languageData.SET_AUTO_PAY}
					</Typography>
					<div className="flex flex-row flex-justify-center flex-center">
						<img src={secureGreen} loading="lazy" className="mt2 mr1" height={20} />
						<Typography variant="Regular200" className="mt2 text-secure" component="span">
							{languageData.SEAMLESS_AND_SECURE}
						</Typography>
					</div>
					<Card className="p4 mb5 mt5 flex flex-row content-center">
						<img src={mandateDetails?.payee_logo} height={48} width={78} className="mr3" />
						<div className="flex flex-column flex-start mt2">
							<Typography variant="Regular300">{mandateDetails?.unity_mandate_details?.payee_name}</Typography>
							<Typography variant="Light100" className="grey">
								{mandateDetails?.unity_mandate_details?.payee_vpa}
							</Typography>
						</div>
					</Card>
					<Card className="p4 mb5 mt5 flex flex-row flex-start flex-justify">
						<Typography variant="Bold400">{languageData.AMOUNT}</Typography>
						<div className="flex flex-column">
							<div>
								<Typography variant="Light200" className="mr2" component="span">
									{languageData.UP_TO}
								</Typography>
								<Typography className="Bold700" component="span">
									₹{mandateDetails?.unity_mandate_details?.amount}
								</Typography>
							</div>
							<div className="auto-debit">
								<Typography component="span">{languageData.AUTO_DEBITED}</Typography>
							</div>
						</div>
					</Card>
					<Card className="p4 mb5 mt5 flex flex-column">
						<div className="flex flex-column flex-start mb3">
							<Typography variant="Light100" className="grey-dark">
								{languageData.FREQUENCY}
							</Typography>
							<Typography variant="Regular300 mt2">As Presented</Typography>
						</div>
						<div className="flex flex-column flex-start mb3">
							<Typography variant="Light100" className="grey-dark">
								{languageData.AUTOPAY_VALIDITY}
							</Typography>
							<Typography variant="Regular300 mt2">
								<>
									{formatDateDynamic(mandateDetails?.mandate_validity_start || ' ', `DD MMM' YYYY`)} -
									{formatDateDynamic(mandateDetails?.mandate_validity_end || ' ', `DD MMM' YYYY`)}
								</>
							</Typography>
						</div>
						<div className="horizontal-dashed-divider bg-white mb3"></div>
						<div className="flex flex-column flex-start mb3">
							<Typography variant="Light200" className="grey">
								{languageData.NOTES}
							</Typography>
							<Typography variant="Regular300 mt2">{mandateDetails?.unity_mandate_details?.note}</Typography>
						</div>
						<div className="horizontal-dashed-divider bg-white mb3"></div>
						<div className="flex flex-column flex-start mb3">
							<Typography variant="Light200" className="grey">
								{languageData.DEBIT_FROM}
							</Typography>
							<div className="flex flex-row flex-center ">
								<img
									src={mandateDetails?.settlement_bank_account_response_dto?.logo}
									loading="lazy"
									className="mt2 mr1"
									height={20}
								/>
								<Typography className="Regular300 mt2">
									{mandateDetails?.settlement_bank_account_response_dto?.name} **** ****{' '}
									{mandateDetails?.settlement_bank_account_response_dto?.account?.slice(-4)}
								</Typography>
							</div>
						</div>
					</Card>
					<div className="content-center">
						<UpiPoweredBy />
					</div>
				</div>
				{showWrongPinModal && (
					<WrongPinModal
						handleClickPrimary={handlePinReset}
						handleClickSecondary={() => handleContinueClick('WRONG_PIN_MODAL')}
						handleModalClose={() => setShowWrongPinModal(false)}
						title={languageData.WRONG_UPI_PIN_ENTERED}
						description={
							languageData.PLEASE_USE_THE_CORRECT_PIN_AND_TRY_AGAIN_YOUR_BANK_WILL_TEMPORARILY_BLOCK_UPI_PAYMENTS_IF_YOU_ENTER_THE_WRONG_PIN_TOO_MANY_TIMES
						}
						primaryButtonName={languageData.RESET_PIN}
						secondaryButtonName={languageData.RETRY}
						icon={AlertIcon}
						type={'info'}
					/>
				)}
				<BottomSheet visible={showPinChangedSuccessfulModal} showCloseButton={false} rounded>
					<div className="p4 flex flex-column">
						<Icon icon={CheckCircle} className="mr2 success-logo" width={40} height={40} />
						<Typography variant="Bold500" className="mt2">
							{languageData.PIN_SUCCESSFULLY_CHANGED}
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb4">
							{languageData.YOU_HAVE_SUCCESSFULLY_UPDATED_YOUR_UPI_PIN_FOR_ACCOUNTNAME_ACCOUNT_ACCOUNTNUMBER.replace(
								'{0}',
								upiData?.upiProfileDetails?.user_banks[0]?.['acc-provider-name'],
							).replace('{1}', account)}
						</Typography>
						<Button onClick={handlePinChnageConfirmationClose} className="mt4">
							{languageData.DONE}
						</Button>
					</div>
				</BottomSheet>
			</>
		</PageLayout>
	);
};
export default AutoPay;
